import React from 'react'
import { NotificationPreferences } from '../../../../components/common/notifications/NotificationPreferences'

export const StudentPreferences = () => {
  return (
    <NotificationPreferences />
  )
}